<template>
  <section class="panel fading">
    <h1>Finally, a little bit about you</h1>
    <div class="text" v-html="text.about_you" v-if="text"></div>
    <div class="form padded">
      <div class="form-left">
        <div class="row">
          <input class="txt" placeholder="Name" type="text" v-model.trim="personal.name" />
        </div>
        <div class="row">
          <input class="txt" placeholder="Telephone" type="tel" v-model.trim="personal.telephone" />
        </div>
        <div class="row">
          <input class="txt" placeholder="Email" type="email" v-model.trim="personal.email" />
        </div>
      </div>
      <div class="form-right">
        <div class="row">
          <textarea class="txt textarea" placeholder="Address" type="text" v-model.trim="personal.address"></textarea>
        </div>
      </div>
    </div>
    <template v-if="personal.type.value == 'new'">
      <div class="text left padded">
        <p>Where will the memorial be located?</p>
      </div>
      <div class="form">
        <div class="form-left">
          <div class="row">
            <input
              class="txt"
              placeholder="Name of churchyard or cemetery"
              type="text"
              v-model.trim="personal.location"
            />
          </div>
        </div>
      </div>
    </template>
    <div class="actions">
      <p class="error" v-if="error">
        <font-awesome-icon icon="exclamation-triangle" />
        {{ error }}
      </p>
      <button @click="$router.back()" class="button back">Back</button>
      <button @click="nav" class="button">
        Finish
        <pulse></pulse>
      </button>
    </div>
  </section>
</template>

<script>
import api from "@/services/api"
import Pulse from "@/components/Pulse.vue"
export default {
  data() {
    return {
      error: "",

      personal: {}
    }
  },
  components: {
    Pulse
  },
  computed: {
    types() {
      return this.$store.state.types
    },
    text() {
      return this.$store.state.text
    }
  },
  created() {
    this.personal = this.$store.state.personal
  },
  methods: {
    nav: function() {
      this.error = ""

      if (
        !this.personal.name ||
        !this.personal.telephone ||
        !this.personal.email ||
        !this.personal.address ||
        !this.personal.location
      ) {
        this.error = "Please fill in each field, thank you"
        return
      }

      if (this.personal.type.value == "rennovation") {
        api
          .lambda("post", "save", {
            personal: this.personal,
            rennovation: this.$store.state.rennovation,
            SiteID: this.$store.state.site_id
          })
          .then(() => this.$router.push("thankyou"))
          .catch(() => (this.error = "There was an error when submitting your request"))
      }

      if (this.personal.type.value == "inscription") {
        api
          .lambda("post", "save", {
            personal: this.personal,
            inscription: this.$store.state.inscription,
            SiteID: this.$store.state.site_id
          })
          .then(() => this.$router.push("thankyou"))
          .catch(() => (this.error = "There was an error when submitting your request"))
      }

      if (this.personal.type.value == "new") {
        api
          .lambda("post", "save", {
            personal: this.personal,
            style: this.$store.state.style,
            inscription_text: this.$store.state.inscription_text,
            selectedExtras: this.$store.state.selectedExtras,
            SiteID: this.$store.state.site_id
          })
          .then(() => this.$router.push("thankyou"))
          .catch(() => (this.error = "There was an error when submitting your request"))
      }
    }
  }
}
</script>

<style scoped>
.panel {
  text-align: center;
}
.form {
  max-width: 80rem;
  margin: auto;
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-gap: 4rem;
}
.padded {
  padding-top: 2rem;
}
.actions {
  padding-top: 5rem;
}
.text.left {
  max-width: 80rem;
  text-align: left;
  margin: auto;
  padding-bottom: 1rem;
  font-family: "Roboto Slab", serif;
  color: #b1ba22;
}
.radios {
  max-width: 80rem;
  text-align: left;
  margin: auto;
}
.txt {
  width: 100%;
  border: 1px solid #e7e7e7;
  border-radius: 0.5rem;
  padding: 1rem 1.5rem;
}
.row {
  margin-bottom: 1rem;
}
.textarea {
  height: 17rem;
}
@media screen and (max-width: 750px) {
  .form {
    grid-template-columns: 1fr;
    grid-gap: 0;
  }
}
</style>
